const styles = theme => ({
    rightContainer: {
        position: 'absolute',
        bottom: '5%',
        right: '2%',
        display: 'flex',
        // '@media screen and (max-width : 1200px)': {
        //     display: 'none',
        // },
    },

    panning: {
        cursor: 'pointer',
        outline: 'none',
        zIndex: 100000,
        height: '32px',
        width: '32px',
        backgroundColor: 'rgba(0,0,0,0.5)',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '&:hover': {
            backgroundColor: 'rgba(0,0,0,0.8)',
        },
    },

    fullScreenStyle: {
        cursor: 'pointer',
        outline: 'none',
        zIndex: 100000,
        height: '32px',
        width: '32px',
        backgroundColor: 'rgba(0,0,0,0.5)',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginLeft: '16px',
        '&:hover': {
            backgroundColor: 'rgba(0,0,0,0.8)',
        },
    },

    imgText: {
        position: 'absolute',
        left: '2%',
        bottom: '5%',
        fontSize: '36px',
        fontWeight: '500',
        letterSpacing: '0',
        lineHeight: '46px',
        textShadow: '2px 2px 2px rgba(0,0,0,0.5)',
        width: '540px',
        color: '#FFFFFF',
        fontFamily: theme.typography.fontFamily,
        '@media screen and (max-width : 1200px)': {
            position: 'absolute',
            left: '5%',
            bottom: '5%',
            height: '25px',
            width: '327px',
            color: '#FFFFFF',
            fontFamily: theme.typography.fontFamily,
            fontSize: '20px',
            fontWeight: '500',
            letterSpacing: '0',
            lineHeight: '25px',
            textShadow: '0 2px 4px 0 rgba(0,0,0,0.8)',
        },
    },
    infoContainer: {
        position: 'absolute',
        right: '0%',
        height: '100%',
    },

    infoIcon: {
        position: 'absolute',
        right: '25px',
        top: '25px',
        zIndex: 1000000,
        height: '32px',
        width: '32px',
        backgroundColor: 'rgba(0,0,0,.5)',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: 'rgba(0,0,0,0.8)',
        },
        '@media screen and (max-width : 1200px)': {
            display: 'none',
        },
    },
    infoPanel: {
        width: '283px',
        height: '100%',
        zIndex: 100000,
        position: 'absolute',
        top: '-1px',
        right: 0,
        display: 'inline-block',
        backgroundColor: 'rgba(0,0,0,0.9)',
        overflowY: 'auto',
    },
    infoDescription: {
        fontFamily: theme.typography.fontFamily,
        position: 'absolute',
        top: '10%',
        left: '10%',
        height: '66px',
        width: '240px',
        color: '#FFFFFF',
        fontSize: '14px',
        fontWeight: '300',
        letterSpacing: '0',
        lineHeight: '22px',
    },
})

export default styles
